<template>
    <div class="pb-12">
        <div class="mx-4 lg:mx-24 pb-16 pt-20 lg:pt-32">
            <div class="flex">
                <div class="text-left mr-4">
                    <h1
                        class="font-display text-xl lg:text-3xl font-semibold tracking-tight text-slate-900 sm:text-7xl">
                        数据驱动制造，助力中小型非标机械厂数智化、精益化转型升级
                    </h1>
                    <!-- <p
                        class="mx-auto mt-12 max-w-6xl tracking-tight text-slate-700 text-sm lg:text-lg leading-loose lg:leading-loose">
                        成都轻熵科技有限责任公司——中小型离散制造加工厂数智化转型解决方案服务商，是一家专注于为中小离散型制造加工厂提供领先生产管理解决方案的创新企业。
                    </p>
                    <p
                        class="mx-auto mt-12 max-w-6xl tracking-tight text-slate-700 text-sm lg:text-lg leading-loose lg:leading-loose">
                        “轻熵”这一名称蕴含着我们追求的理念——创造有序、高效的生产环境。我们深知，工厂的生产管理面临着多重挑战，尤其是在库存过剩、生产周期长、交期不准等方面。我们的解决方案通过数字化、智能化、精益化的方式，帮助工厂精准管理生产全过程，快速识别并突破生产瓶颈，减少生产浪费，从而加快产品流动，缩短产品生产周期，优化库存水平，提升订单准交率，最终提升工厂盈利水平。
                    </p>
                    <p
                        class="mx-auto mt-12 max-w-6xl tracking-tight text-slate-700 text-sm lg:text-lg leading-loose lg:leading-loose">
                        在轻熵科技，我们不仅提供一款功能强大的生产管理软件，更通过技术创新帮助工厂实现精益化生产。我们相信，通过精益思想与数字化技术的结合，工厂能够实现更高效、更智能的生产方式，推动企业实现持续发展与盈利的目标。
                    </p>
                    <p
                        class="mx-auto mt-12 max-w-6xl tracking-tight text-slate-700 text-sm lg:text-lg leading-loose lg:leading-loose">
                        我们的目标是成为您可信赖的合作伙伴，为您提供全面的解决方案和持续的技术支持，助力您的企业在激烈的市场竞争中脱颖而出。 </p>
                    <p
                        class="mx-auto mt-12 max-w-6xl tracking-tight text-slate-700 text-sm lg:text-lg leading-loose lg:leading-loose">

                        欢迎联系我们，了解更多关于我们产品的详情，让我们共同开启数智化精益转型之旅。 </p> -->
                    <p
                        class="mx-auto mt-12 max-w-6xl tracking-tight text-slate-700 text-sm lg:text-lg leading-loose lg:leading-loose">
                        成都轻熵科技有限责任公司，是家专注于为中小非标机械厂提供 ERP & MES 一体化管理系统解决方案（支持非标定制）的服务商。
                    </p>
                    <p
                        class="mx-auto mt-12 max-w-6xl tracking-tight text-slate-700 text-sm lg:text-lg leading-loose lg:leading-loose">
                        “轻熵”这一名称蕴含着我们不懈追求的理念一一通过数字化技术为中小非标机械厂创造有序、高效的生产环境。
                    </p>
                    <p
                        class="mx-auto mt-12 max-w-6xl tracking-tight text-slate-700 text-sm lg:text-lg leading-loose lg:leading-loose">
                        我们深知，中小非标机械厂的生产管理面临着多重挑战，尤其是在生产进度不透明、在制品易堆积、产品生产周期长、订单交期不准时等方面。我们的解决方案通过数字化、智能化、精益化的方式，帮助工厂高效管理产品从下单生产到出货对账全流程。通过将业务流程数字化、透明化，减少各环节非增值时间浪费，助力工厂实现更低成本的快速交货。
                    </p>
                </div>

                <img class="rounded-[12px] hidden lg:block" width="45%" src="@/assets/imgs/bg1.jpg">
            </div>
        </div>
        <div class="flex flex-col lg:flex-row justify-between my-8 mx-4 lg:mx-24 text-[20px]">
            <div
                class="other-container flex flex-col justify-center items-center py-3 lg:py-6 rounded-[12px] lg:rounded-[30px]">
                <a-icon class="bg-[#f3f4f7] px-4 py-3 rounded-xl" type="team" />
                <p class="mt-4 lg:mt-8 text-sm lg:text-base font-semibold">我们的团队</p>
                <p class="mt-2 text-sm px-6">拥有头部互联网+工业软件+工厂管理背景，来自国内外一流高校</p>
            </div>
            <div
                class="other-container flex flex-col justify-center items-center lg:ml-40 mt-4 lg:mt-0 py-3 lg:py-6 rounded-[12px] lg:rounded-[30px]">
                <a-icon class="bg-[#f3f4f7] px-4 py-3 rounded-xl" type="laptop" />
                <p class="mt-4 lg:mt-8 text-sm lg:text-base font-semibold">办公地点</p>
                <p class="mt-2 text-sm">四川省成都市龙泉驿区车城西二路菁蓉数字经济产业园2栋1F-111号</p>
            </div>
        </div>
        <div class="flex flex-col lg:flex-row justify-between mx-4 lg:mx-24 my-8">
            <div
                class="other-container flex flex-col justify-center items-center py-3 lg:py-6 rounded-[12px] lg:rounded-[30px]">
                <img class="w-[46px] h-[46px]" src="@/assets/imgs/address.png" />
                <p class="mt-4 lg:mt-8 text-sm lg:text-base font-semibold">联系地址</p>
                <p class="mt-2 text-sm">四川省成都市龙泉驿区车城西二路菁蓉数字经济产业园2栋1F-111号</p>
            </div>
            <div
                class="other-container flex flex-col justify-center items-center lg:ml-40 mt-4 lg:mt-0 py-3 lg:py-6 rounded-[12px] lg:rounded-[30px]">
                <img class="w-[46px] h-[46px]" src="@/assets/imgs/email.png" />
                <p class="mt-4 lg:mt-8 text-sm lg:text-base font-semibold">联系我们</p>
                <p class="mt-2 text-sm">联系电话：白先生 13364061501（微信同号）</p>
            </div>
        </div>

        <home-page-to-contact />
        <home-page-contact />
    </div>
</template>

<script>
import HomePageContact from './components/contact';
import HomePageToContact from './components/to-contact';

export default {
    name: 'homePageIndex',
    components: {
        HomePageContact,
        HomePageToContact
    }
}
</script>
<style scoped>
.title-desc {
    background-color: #eef4ff;
}

.main-wrap {
    background-image: linear-gradient(#fff, #ffffff99), url(@/assets/imgs/bg1.jpg);
    background-position: top;
    background-size: cover;
}

.other-container {
    flex: 1;
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.03), 0px 0px 1px 0px rgba(0, 0, 0, 0.25);
}
</style>
